import { render, staticRenderFns } from "./AddVehicleContent.vue?vue&type=template&id=4785efb1&scoped=true"
import script from "./AddVehicleContent.vue?vue&type=script&lang=ts"
export * from "./AddVehicleContent.vue?vue&type=script&lang=ts"
import style0 from "./AddVehicleContent.vue?vue&type=style&index=0&id=4785efb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785efb1",
  null
  
)

export default component.exports